import { useTranslation } from 'react-i18next'
import ReorderPage from '../components/ReorderPage'

const ReligiousDuesReorder = () => {
    const { t } = useTranslation()

    return (
        <div className='min-h-screen bg-gray-100'>
            <ReorderPage
                fetchEndpoint='/admin/religious-dues'
                reorderEndpoint='/admin/religious-dues/reorder'
                title={t('reorder.reorder_dues')}
                getItemImage={item =>
                    item.featured_image || item.image_preview || item.header_image || ''
                }
                getItemTitle={item => item.title || item.name}
                successEndpoint='/admin/auth/religious-dues'
            />
        </div>
    )
}

export default ReligiousDuesReorder
